export async function signData(data: any, wallet: string, provider: any): Promise<string> {
    return await provider.request({
        method: "personal_sign",
        params: [data, wallet]
    })
}
